import React from "react";
import { useNavigate } from "react-router-dom";

const ReportsMenu = ({ onNavigate }) => {
  const navigate = useNavigate();

  const handleClick = (view) => {
    navigate(`/reports?view=${view}`);

    if (typeof onNavigate === "function") {

      onNavigate();
    }
  };

  const items = [
    { key: "income", label: "Income" },
    { key: "expenses", label: "Expense" },
    { key: "both", label: "Both" },
  ];

  return (
    <div className="flex flex-col w-40">
      {items.map(({ key, label }) => (
        <button
          key={key}
          onClick={() => handleClick(key)}
          className="px-4 py-2 text-left hover:text-[#2ecfe3] hover:bg-gray-100 transition-colors duration-150"
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default ReportsMenu;
